<template>
  <div class="page page-about-us">
    <company-intro-nav-bar />
    <div class="about-content">
      <ym-img class="img"
              :src="require('@/assets/img/aboutus/2021/1.png')"
              alt=""
      />
      <ym-img class="img img-2"
              :src="require('@/assets/img/aboutus/2021/2.png')"
              alt=""
      />
      <ym-img class="img"
              :src="require('@/assets/img/aboutus/2021/3.png')"
              alt=""
      />
      <div class="img-box">
        <ym-img class="img img-4"
                :src="require('@/assets/img/aboutus/2021/4.png')"
                alt=""
        />
        <ym-img class="img"
                :src="require('@/assets/img/aboutus/2021/5.png')"
                alt=""
        />
        <ym-img class="img img-6"
                :src="require('@/assets/img/aboutus/2021/6.png')"
                alt=""
        />
        <ym-img class="img img-7"
                :src="require('@/assets/img/aboutus/2021/7.png')"
                alt=""
        />
      </div>
      <ym-img class="img img-8"
              :src="require('@/assets/img/aboutus/2021/8.png')"
              alt=""
      />
      <ym-img class="img"
              :src="require('@/assets/img/aboutus/2021/9.png')"
              alt=""
      />
      <div class="video-block">
        <ym-video class="video"
                  src="https://large.download.quketang.com/marketing/video/ymba_remark_181221.mp4"
                  poster="https://download.quketang.com/android/DavidKelley.png"
        />
        <span>*斯坦福d.school创办人及教育学院院长等著名教育家对少年商学院的认可与鼓励</span>
      </div>
      <router-link class="link" :to="{ name: 'ArticleDetail', params: { id: 302 } }">
        <ym-img class="img zhanghua-book"
                :src="require('@/assets/img/aboutus/zhanghua-book.png')"
                alt=""
        />
      </router-link>
      <ym-img class="img img-9"
              :src="require('@/assets/img/aboutus/2020/9.png')"
              alt=""
      />
      <div class="partner-grid">
        <div class="partner-grid-block">
          <router-link :to="{ name: 'ArticleDetail', params: { id: 120 } }">
            <ym-img class="img partner-grid-item-1"
                    :src="require('@/assets/img/aboutus/2020/10_1.png')"
                    alt=""
            />
          </router-link>
          <router-link :to="{ name: 'ArticleDetail', params: { id: 99 } }">
            <ym-img class="img partner-grid-item-2"
                    :src="require('@/assets/img/aboutus/2020/10_2.png')"
                    alt=""
            />
          </router-link>
          <router-link :to="{ name: 'ArticleDetail', params: { id: 104 } }">
            <ym-img class="img partner-grid-item-3"
                    :src="require('@/assets/img/aboutus/2020/10_3.png')"
                    alt=""
            />
          </router-link>
          <router-link :to="{ name: 'ArticleDetail', params: { id: 185 } }">
            <ym-img class="img partner-grid-item-4"
                    :src="require('@/assets/img/aboutus/2020/10_4.png')"
                    alt=""
            />
          </router-link>
        </div>
        <div class="partner-grid-block">
          <router-link :to="{ name: 'ArticleDetail', params: { id: 176 } }">
            <ym-img class="img partner-grid-item-5"
                    :src="require('@/assets/img/aboutus/2020/10_5.png')"
                    alt=""
            />
          </router-link>
          <router-link :to="{ name: 'ProjectDetail', params: { id: 126 } }">
            <ym-img class="img partner-grid-item-6"
                    :src="require('@/assets/img/aboutus/2020/10_6.png')"
                    alt=""
            />
          </router-link>
          <router-link :to="{ name: 'ArticleDetail', params: { id: 121 } }">
            <ym-img class="img partner-grid-item-7"
                    :src="require('@/assets/img/aboutus/2020/10_7.png')"
                    alt=""
            />
          </router-link>
          <router-link :to="{ name: 'ArticleDetail', params: { id: 142 } }">
            <ym-img class="img partner-grid-item-8"
                    :src="require('@/assets/img/aboutus/2020/10_8.png')"
                    alt=""
            />
          </router-link>
        </div>
        <div class="partner-grid-block">
          <router-link :to="{ name: 'ArticleDetail', params: { id: 199 } }">
            <ym-img class="img partner-grid-item-9"
                    :src="require('@/assets/img/aboutus/2020/10_9.png')"
                    alt=""
            />
          </router-link>
          <ym-img class="img partner-grid-item-10"
                  :src="require('@/assets/img/aboutus/2020/10_10.png')"
                  alt=""
          />
          <ym-img class="img partner-grid-item-11"
                  :src="require('@/assets/img/aboutus/2020/10_11.png')"
                  alt=""
          />
          <router-link :to="{ name: 'ArticleDetail', params: { id: 201 } }">
            <ym-img class="img partner-grid-item-12"
                    :src="require('@/assets/img/aboutus/2020/10_12.png')"
                    alt=""
            />
          </router-link>
        </div>
      </div>
      <router-link :to="{ name: 'CompanyPartner' }">
        <ym-img class="img img-11"
                :src="require('@/assets/img/aboutus/2020/11.png')"
                alt=""
        />
      </router-link>
      <ym-img class="img img-12"
              :src="require('@/assets/img/aboutus/2020/12.png')"
              alt=""
      />
      <ym-img class="img"
              :src="require('@/assets/img/aboutus/2021/13.png')"
              alt=""
      />
      <ym-img class="img img-14"
              :src="require('@/assets/img/aboutus/2020/14.png')"
              alt=""
      />

      <div class="content-block">
        <div class="list-block media-list core-person-list">
          <!-- eslint-disable max-len -->
          <ul>
            <li>
              <div class="item-content">
                <div class="item-media">
                  <ym-img class="img"
                          :src="require('@/assets/img/aboutus/2020/15_1.png')"
                          alt="张华"
                  />
                </div>
                <div class="item-inner">
                  <div class="item-title">张 华</div>
                  <div class="item-subtitle">创始人兼CEO</div>
                </div>
              </div>
              <div class="item-info">
                少年商学院创始人兼CEO，青少年财商与领导力教育专家，在线素质教育行业的先行者，英国《金融时报》中文网专栏作家。曾承担教育部教育管理信息中心《互联网+教育背景下中小学生核心素养和创新能力发展研究》课题研究。创业前为知名财经媒体人，笔名东方愚，任职于《南方周末》，采访调研近百位国内外知名企业家。出版有《中国富豪这十年》（与胡润合著）《敢让孩子做自己》<router-link class="link" :to="{ name: 'ArticleDetail', params: { id: 302 } }">《世界是我们的课堂》</router-link>等畅销书。
                <p>
                  <br/>
                  E-mail：<span class="color-primary">
                  zhanghua#<span class="hidden">wwwyouthmba</span>youthMBA.com</span>（请将#改为@）
                </p>
              </div>
            </li>
<!--            <li>-->
<!--              <div class="item-content">-->
<!--                <div class="item-media">-->
<!--                  <ym-img class="img"-->
<!--                          :src="require('@/assets/img/aboutus/2020/15_2.png')"-->
<!--                          alt="Evan Wang"-->
<!--                  />-->
<!--                </div>-->
<!--                <div class="item-inner">-->
<!--                  <div class="item-title">Evan Wang</div>-->
<!--                  <div class="item-subtitle">联合创始人兼教研总监</div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item-info">-->
<!--                毕业于美国加州大学伯克利分校，曾在硅谷中学任教。后曾赴斯坦福大学交流学习设计思维（<i>Design Thinking</i>），并获 <i>d.school</i> 创办人授权与支持，向中国青少年普及这一创新思维与实践方法。他对青少年跨学科学习及自驱型成长等课题有着深入的研究与丰富经验，他主持的“少年爱问”万物启蒙脱口秀节目也深受孩子们喜欢。Evan 还是全球设计思维峰会演讲嘉宾和中国传媒大学特聘专家。-->
<!--                <p>-->
<!--                  <br/>-->
<!--                  E-mail：<span class="color-primary">-->
<!--                  Evan#<span class="hidden">wwwyouthmba</span>youthMBA.com</span>（请将#改为@）-->
<!--                </p>-->
<!--              </div>-->
<!--            </li>-->
            <li>
              <div class="item-content">
                <div class="item-media">
                  <ym-img class="img"
                          :src="require('@/assets/img/aboutus/2020/15_3.png')"
                          alt="Allen"
                  />
                </div>
                <div class="item-inner">
                  <div class="item-title">赖庆明</div>
                  <div class="item-subtitle">联合创始人兼技术总监</div>
                </div>
              </div>
              <div class="item-info">
                资深 <i>IT</i> 工程师，前荔枝FM创始团队成员。逾十年互联网产品开发和管理经验。创办过国内最早融合 <i>Scratch</i>、<i>Minecraft</i> 与乐高编程的青少年教育社区。现致力于中小学生在线教育整体解决方案的开发与应用。
                <p>
                  <br/>
                  E-mail：<span class="color-primary">
                  Allen#<span class="hidden">wwwyouthmba</span>youthMBA.com</span>（请将#改为@）
                </p>
              </div>
            </li>
          </ul>
          <!-- eslint-disable max-len -->
        </div>
      </div>

      <div class="contact-info">
        <div class="contact-info-block">
          <div class="contact-info-block-title">
            优秀作品
          </div>
          <div class="contact-info-block-content">
            少年商学院目前已累积丰富的创意实践作品，<br/>
            欢迎<router-link :to="{ name: 'WorkIndex' }">
              <span class="link color-primary">点击这里</span>
            </router-link>查看
          </div>
        </div>
        <div class="contact-info-block">
          <div class="contact-info-block-title">
            联系我们
          </div>
          <div class="contact-info-block-content">
            <span class="high-light">欢迎联系我们，并请留下您的联系信息：</span><br/>
            商务合作请发介绍材料：
            <span class="color-primary">
              contact@<span class="hidden">wwwyouthmba</span>youthmba.com
            </span>
            <br/>
            投稿及公开课嘉宾推荐：
            <span class="color-primary">
              post@<span class="hidden">wwwyouthmba</span>youthmba.com
            </span>
            <br />
            欢迎志趣相投的伙伴加入我们：
            <span class="color-primary">
              hr@<span class="hidden">wwwyouthmba</span>youthmba.com
            </span>
            <br />
            最新招聘启事：
            <router-link class="link color-primary"
                         :to="{ name: 'JoinUs' }"
            >
              点击这里
            </router-link>
          </div>
        </div>
        <div class="contact-info-block">
          <div class="contact-info-block-title">
            公司地址
          </div>
          <div class="contact-info-block-content">
            总部：中国广州市海珠区聚德路221号世联空间C601室
          </div>
          <div class="contact-info-block-content">
            深圳：深圳市南山区前海深港青年梦工场10号楼2楼207
          </div>
        </div>
      </div>

      <ym-img class="img img-logo"
              :src="require('@/assets/img/default/logo.png')"
              alt=""
      />
    </div>
  </div>
</template>

<script>
  import CompanyIntroNavBar from '@/components/CompanyIntroNavbar';
  import { getStaticShareInfo } from '@/services/app';
  import YmVideo from '@/components/YmVideo';

  export default {
    name: 'PageAboutUs',
    metaInfo: {
      title: '关于我们',
    },
    components: {
      CompanyIntroNavBar,
      YmVideo,
    },
    methods: {
      async getStaticShareInfo() {
        await getStaticShareInfo({
          type: 'aboutus',
        });
      },
    },
    created() {
      this.getStaticShareInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-about-us {
    box-sizing: border-box;
    padding-top: @size-small;
    padding-bottom: @size-large;
    background: @color-white;
  }

  .about-content {
    font-size: @font-size-base;
    color: @color-black-light;
    line-height: 1.6;
  }

  .img {
    display: block;
    width: 100%;
  }

  .img-2 {
    margin: 60px auto;
  }
  .img-box {
    background-color: #ddf0f0;
    margin-top: 75px;
    overflow: hidden;
  }
  .img-4 {
    margin: 90px auto 30px;
  }
  .img-6 {
    margin: 117px auto 35px;
  }
  .img-7 {
    margin-bottom: 57px;
  }
  .zhanghua-book {
    width: 100%;
    margin: 60px auto 0;
  }
  .img-8 {
    width: 528px;
    height: 35px;
    margin: 117px auto 67px;
  }
  .img-9 {
    width: 492px;
    height: 34px;
    margin: 60px auto 70px;
  }
  .img-11 {
    margin: @size-medium auto 100px;
    width: 364px;
    height: 68px;
  }
  .img-12 {
    margin: 0 auto 70px;
    width: 492px;
    height: 36px;
  }
  .img-14 {
    margin: 110px auto @size-extra-medium;
    width: 430px;
    height: 34px;
  }
  .img-logo {
    margin: 90px auto 0;
    width: 270px;
  }

  .video-block {
    margin: 58px auto 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .video {
      width: 664px;
      height: 374px;
    }
    span {
      margin-top: 16px;
      color: @color-text-lighter;
      font-size: 18px;
      line-height: 1;
      text-align: center;
    }
  }

  .partner-grid {
    box-sizing: border-box;
    padding: 0 @size-medium;
    &-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:not(:last-child) {
        margin-bottom: @size-base;
      }
    }
    &-item-1 {
      width: 86px;
      height: 66px;
    }
    &-item-2 {
      width: 66px;
      height: 68px;
    }
    &-item-3 {
      width: 190px;
      height: 40px;
    }
    &-item-4 {
      width: 180px;
      height: 70px;
    }
    &-item-5 {
      width: 150px;
      height: 46px;
    }
    &-item-6 {
      width: 136px;
      height: 46px;
    }
    &-item-7 {
      width: 44px;
      height: 63px;
    }
    &-item-8 {
      width: 138px;
      height: 60px;
    }
    &-item-9 {
      width: 86px;
      height: 54px;
    }
    &-item-10 {
      width: 128px;
      height: 70px;
    }
    &-item-11 {
      width: 168px;
      height: 46px;
    }
    &-item-12 {
      width: 196px;
      height: 58px;
    }
  }

  .content-block {
    padding: 0 @size-large;
  }

  .content-title {
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-primary;
  }

  .color-primary {
    color: @color-primary;
    font-weight: @font-weight-bold;
  }

  .core-person-list {
    margin: @size-small 0;
    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }
    li {
      margin-bottom: @size-large;
      list-style-type: none;
    }
    .item-content {
      display: flex;
      align-items: center;
      padding-left: 0;
      margin-bottom: @size-medium;
    }
    .item-media {
      padding: 0;
      .img {
        width: 134px;
      }
    }
    .item-inner {
      margin-left: @size-base;
    }
    .item-title {
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      color: @color-primary;
      overflow: inherit;
      line-height: 1.2;
    }
    .item-subtitle {
      margin-top: @size-extra-small;
      font-size: @font-size-small;
      line-height: 1.2;
    }
    .item-info {
      p {
        margin: 0;
        padding: 0;
      }
      .link {
        color: @color-primary;
        border-bottom: 1px solid @color-primary;
      }
    }
  }

  .contact-info {
    box-sizing: border-box;
    margin: 0 auto;
    padding: @size-base;
    width: 690px;
    border: @border-width-base @border-style-base @color-primary;
    border-radius: @border-radius-medium;
    &-block {
      &:not(:last-child) {
        margin-bottom: @size-extra-large;
      }

      &-title {
        width: 146px;
        height: 46px;
        margin-bottom: @size-small;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
        background: @color-primary;
        border-radius: @border-radius-medium;
      }

      &-content {
        color: @color-text-lighter;
        font-size: @font-size-small;
        line-height: 2;

        .work-num {
          color: @color-primary;
          font-weight: @font-weight-bold;
        }

        .link {
          font-weight: @font-weight-bold;
          border-bottom: @border-style-base @border-width-base @color-primary;
        }
      }
    }
  }

</style>
